module.exports = __webpack_public_path__ + "static/media/DQStarsRating_2STAR.2f8daa68.png";